/*
*
* Buildpath - Misc Javscript for FSLightbox Customization
*
*/
document.addEventListener('DOMContentLoaded', function() {
    
    /* Preload images for mobile lightbox */
    var fslightboxLinks = document.querySelectorAll('[data-fslightbox="pdp-gallery__mobile"]');
    var preloadImages = [];
  
    for (var i = 0; i < fslightboxLinks.length && i < 5; i++) {
      var img = new Image();
      img.src = fslightboxLinks[i].getAttribute('data-image-url');
      img.onload = function() {
        // console.log('Image preloaded:', this.src);
      };
      img.onerror = function() {
        // console.error('Failed to preload image:', this.src);
      };
      preloadImages.push(img);
    }
  
    //Define lightboxes for desktop and mobile
    const lightbox_desktop = window.fsLightboxInstances["pdp-gallery__desktop"];
    const lightbox_mobile = window.fsLightboxInstances["pdp-gallery__mobile"];

    if (lightbox_desktop) {
        // Mobile Lightbox Customizations
        console.log('lightbox_desktop - ', lightbox_desktop);
        var videoElementsDesktop = [];
    
        lightbox_desktop.props.onOpen = function () {
            console.log('lightbox_desktop opened');

            // If the active slide is a video, play it and pause the trigger video in the flickity slider
            const currentSlideIndex = lightbox_desktop.stageIndexes.current;
            const currentSlide = lightbox_desktop.elements.sources[currentSlideIndex];
            if (currentSlide.tagName.toLowerCase() === 'video') {
                console.log('lightbox_desktop - onOpen: current slide IS a video');
                currentSlide.play();
                var videoLink = document.querySelector(".pdp-video-desktop");
                var originalVideo = videoLink.querySelector("video");
                originalVideo.pause();    
            }
            // console.log('lightbox_desktop - ', lightbox_desktop);
            // console.log('lightbox_desktop container: ', lightbox_desktop.elements.container);
        }
        
        lightbox_desktop.props.onInit = function () {
            console.log('lightbox_desktop - onInit ');
            //Add video elements to an array
            const sources = lightbox_desktop.elements.sources;
           
            // If the active slide is a video, play it and pause the trigger video in the flickity slider
            const currentSlideIndex = lightbox_desktop.stageIndexes.current;
            const currentSlide = lightbox_desktop.elements.sources[currentSlideIndex];
            if (currentSlide.tagName.toLowerCase() === 'video') {
                console.log('onInit: current slide IS a video');
                currentSlide.play();
                setTimeout(function() {
                    document.querySelector(".pdp-video-desktop video").pause(); 
                }, 50);
            }
            
            for (let i = 0; i < sources.length; i++) {
                const source = sources[i];
                //create a videoElementsDesktop array
                if (source && source.tagName === 'VIDEO') {
                    videoElementsDesktop.push(source);
                }
            }
            console.log('videoElementsDesktop: ', videoElementsDesktop);        
          
            // Preload all slide images
            for (var i = 0; i < lightbox_desktop.props.sources.length; i++) {
              var img = new Image();
              img.src = lightbox_desktop.props.sources[i];
              // console.log('Lightbox Image preloaded:', img.src);
            }
        };

        lightbox_desktop.props.onClose = function () {
            //On every close of the lightbox.
            const currentSlideIndex = lightbox_desktop.stageIndexes.current;
            const currentSlide = lightbox_desktop.elements.sources[currentSlideIndex];
            if (currentSlide.tagName.toLowerCase() === 'video') {
                // console.log('current slide IS a video');
                currentSlide.pause();
                setTimeout(function() {
                    document.querySelector(".video-play-button").classList.add("hide"); 
                    document.querySelector(".pdp-video-desktop video").play(); 
                }, 50);
            }
        }
    
        
    
        lightbox_desktop.props.onSlideChange = function () {
            const currentSlideIndex = lightbox_desktop.stageIndexes.current;
            console.log('Slide has changed to:', currentSlideIndex);          
            const currentSlide = lightbox_desktop.elements.sources[currentSlideIndex];
               
          
            if (currentSlide.tagName.toLowerCase() === 'video') {
                console.log('current slide IS a video');
                currentSlide.play();
            }
            else {
                console.log('current slide is NOT a video');
                videoElementsDesktop.forEach(function(videoElement) {
                    console.log('trying to pause video(s) in videoElementsDesktop array.');
                    if (!videoElement.paused)
                    console.log('found a video. pausing it');
                       videoElement.pause();
                });
            }
    
           
            
          };
          
    }

    if (lightbox_mobile) {
        // Mobile Lightbox Customizations
        console.log('lightbox_mobile - ', lightbox_mobile);
        var videoElementsMobile = [];

        lightbox_mobile.props.onOpen = function () {
            console.log('lightbox_mobile opened');

            // If the active slide is a video, play it and pause the trigger video in the flickity slider
            const currentSlideIndex = lightbox_mobile.stageIndexes.current;
            const currentSlide = lightbox_mobile.elements.sources[currentSlideIndex];
            if (currentSlide.tagName.toLowerCase() === 'video') {
                console.log('lightbox_mobile - onOpen: current slide IS a video');
                currentSlide.play();
                setTimeout(function() {
                    document.querySelector(".pdp-video-mobile video").pause(); 
                }, 50);
            }
        }
        
        lightbox_mobile.props.onInit = function () {
            console.log('lightbox_mobile - onInit');
            //Add video elements to an array
            const sources = lightbox_mobile.elements.sources;
          
            
            for (let i = 0; i < sources.length; i++) {
                const source = sources[i];
                //create a videoelements array
                if (source && source.tagName === 'VIDEO') {
                    videoElementsMobile.push(source);
                }
            }
            console.log('videoElementsMobile: ', videoElementsMobile);        
          
            // Preload all slide images
            for (var i = 0; i < lightbox_mobile.props.sources.length; i++) {
              var img = new Image();
              img.src = lightbox_mobile.props.sources[i];
              // console.log('Lightbox Image preloaded:', img.src);
            }
        };

        

        lightbox_mobile.props.onSlideChange = function () {
            const currentSlideIndex = lightbox_mobile.stageIndexes.current;
            console.log('lightbox_mobile - Slide has changed to:', currentSlideIndex);          
            const currentSlide = lightbox_mobile.elements.sources[currentSlideIndex];
               
          
            if (currentSlide.tagName.toLowerCase() === 'video') {
                console.log('lightbox_mobile - current slide IS a video');
                currentSlide.play();
            }
            else {
                console.log('lightbox_mobile - current slide is NOT a video');
                videoElementsMobile.forEach(function(videoElement) {
                    console.log('lightbox_mobile - trying to pause video(s) in videoElements array.');
                    if (!videoElement.paused)
                    console.log('lightbox_mobile - found a video. pausing it');
                       videoElement.pause();
                });
            }        
        };

        lightbox_mobile.props.onClose = function () {
            //On every close of the lightbox.
            const currentSlideIndex = lightbox_mobile.stageIndexes.current;
            const currentSlide = lightbox_mobile.elements.sources[currentSlideIndex];
            if (currentSlide.tagName.toLowerCase() === 'video') {
                // console.log('current slide IS a video');
                currentSlide.pause();
                setTimeout(function() {
                    document.querySelector(".video-play-button").classList.add("hide"); 
                    document.querySelector(".pdp-video-mobile video").play(); 
                }, 50);
            }
        }


          
    }
    
});